import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { TreeItem } from '../../models/tree-item';
import { ConnectProviderService } from 'app/connect/core/connect-provider.service';
import { I18nService } from 'i18n/i18n.service';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';

@Component({
  selector: 'connect-replication-detail-schedule',
  templateUrl: 'connect-replication-detail-schedule.component.html',
  styleUrls: ['connect-replication-detail-schedule.component.scss']
})
export class ConnectReplicationDetailScheduleComponent implements OnInit, AfterViewChecked, OnChanges {

  public enableReplication: boolean = true;
  public showErrorStarting: boolean = false;
  public limitMinimumDate: boolean = false;
  public limitMaxDate: boolean = false;

  public minutesEndingAt: string = '00';
  public minutesStartingAt: string = '00';
  public hoursEndingAt: string = '00';
  public hoursStartingAt: string = '00';

  public dailyFrecuency: string = 'Once';
  public frecuencyType: string = '0';
  public occursEvery: string = 'Minutes';
  public startDate: string = '';

  public beginningDate: Date  = new Date();

  public schedule: any = null;
  public scheduleObj: any = null;
  public changeSet: any = {};
  public daysOfWeek: Array<string> = [];


  @Input() currentItemSelected: TreeItem;

  constructor(private _connectProviderService: ConnectProviderService,
              private _i18nService: I18nService,
              private _toastService: BzgToastService,
              private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.defaultValues();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  defaultValues() {
    this._connectProviderService.getInfoById(this.currentItemSelected.id).subscribe((data: any) => {
      this.scheduleObj = data;
      this.schedule = data.content.schedules[0];
      this.enableReplication = this.scheduleObj.content.enabled;
      this.setValues();
    });
  }

  setValues() {
    const indexStart = this.schedule.startDate.indexOf('T');
    if (indexStart)
      this.startDate = this.schedule.startDate.substring(0, indexStart);
    if (this.schedule.dailyExecution.type !== 'Once')
    {
      this.dailyFrecuency = 'Every';
      this.occursEvery = this.schedule.dailyExecution.type;
      this.minutesEndingAt = this.getMinutes('endHour');
      this.hoursEndingAt = this.getHours('endHour');
    }
    this.minutesStartingAt = this.getMinutes('startHour');
    this.hoursStartingAt = this.getHours('startHour');

    if (this.schedule.dailyExecution.type === 'Once') {
      this.minutesEndingAt = '00';
      this.hoursEndingAt = '00';
      this.dailyFrecuency = 'Once';
      this.showErrorStarting = false;
    }

  }

  changeEnableRepllication() {
    this.scheduleObj.content.enabled = !this.scheduleObj.content.enabled;
    this.enableReplication = this.scheduleObj.content.enabled;
  }

  changeFrequency(valueFrecuency) {
    this.schedule.frequency.type = valueFrecuency;
  }

  changeDaysOfWeek(days) {
    this.schedule.daysOfWeek = days;
  }

  changeFrequencyRecurrence(recurrence) {
    this.schedule.frequency.recurrence = recurrence;
  }

  changeDayOfMonth(dayOfMonth) {
    this.schedule.dayOfMonth = dayOfMonth;
  }

  changeDailyFrecuency(frequency) {
    this.dailyFrecuency = frequency;
    this.showErrorStarting = false;
    if (this.dailyFrecuency === 'Once') {
      this.schedule.dailyExecution.type = frequency;
      this.schedule.dailyExecution.recurrence = 0;
      this.schedule.endHour = '00:00:00';
      this.minutesEndingAt = '00';
      this.hoursEndingAt = '00';
    }
    else
      this.schedule.dailyExecution.type = this.occursEvery;
  }

  changeEverySelected(occursEvery) {
    this.schedule.dailyExecution.type = occursEvery;
    this.occursEvery = occursEvery;
  }

  changeDailyFrequencyRecurrence(dailyFrequencyRecurrence) {
    this.schedule.dailyExecution.recurrence = dailyFrequencyRecurrence;
  }

  changeStartDate(startDate) {
    const indexStart = this.startDate.indexOf('-');
    let year = '';
    if (indexStart)
    {
      year = this.startDate.substring(0, indexStart);
      this.limitMaxDate = parseInt(year, 10) > 3000 ? true : false;
    }
    this.schedule.startDate = startDate + `T${this.hoursStartingAt}:${this.minutesStartingAt}:00`;
    this.limitMinimumDate = Date.parse(this.schedule.startDate) < Date.parse('1753-01-01T00:00:00') ? true : false;
  }

  getHours(field) {
    return this.schedule[field].substring(0, 2);
  }

  getMinutes(field) {
    return this.schedule[field].substring(3, 5);
  }

  onCancel() {
    this.defaultValues();
  }

  saveAll() {
    if (this.schedule.frequency.type !== 'Weekly')
      this.schedule.daysOfWeek = [];
    if (this.schedule.frequency.type !== 'Monthly')
      this.schedule.dayOfMonth = 0;
    this.scheduleObj.action = 'Merge';
    this.scheduleObj.content.schedules[0] = {};
    this.scheduleObj.content.schedules[0] = this.schedule;
    this.changeSet.changeSet = [];
    this.changeSet.changeSet.push(this.scheduleObj);
    this._connectProviderService.postSchedule(this.changeSet).subscribe(result => {
      this.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success', 5000);
    });
  }

  showErrorWeek() {
    return this.schedule && this.schedule.frequency.type === 'Weekly' &&
      (!this.schedule.daysOfWeek || this.schedule.daysOfWeek.length === 0);
  }

  changeOccursEvery(date, isHour, isEndingAt) {
    this.validateTime(date, isHour, isEndingAt);

    const dateEndingAt = new Date();
    dateEndingAt.setHours(parseInt(this.hoursEndingAt, 10), parseInt(this.minutesEndingAt, 10));

    const dateStartingAt = new Date();
    dateStartingAt.setHours(parseInt(this.hoursStartingAt, 10), parseInt(this.minutesStartingAt, 10));
    this.validateDates(dateStartingAt, dateEndingAt);

    if (this.schedule)
    {
      const indexStart = this.schedule.startDate.indexOf('T');
      if (indexStart) {
        const oldHour = this.schedule.startDate.substring(indexStart + 1);
        this.schedule.startDate = this.schedule.startDate.replace(oldHour, `${this.hoursStartingAt}:${this.minutesStartingAt}:00`);
      }

      this.schedule.startHour = `${this.hoursStartingAt}:${this.minutesStartingAt}:00`;
      this.schedule.endHour = `${this.hoursEndingAt}:${this.minutesEndingAt}:00`;
    }
  }

  validateTime(date, isHour, isEndingAt) {
    if (Number.isInteger(date)) {
      if (date < 10)
        date = '0' + date;
    }
    if (isEndingAt) {
      if (isHour)
        this.hoursEndingAt = date;
      else
        this.minutesEndingAt = date;
    } else {
      if (isHour)
        this.hoursStartingAt = date;
      else
        this.minutesStartingAt = date;
    }
  }

  validateDates(fechainicial, fechafinal) {
    this.showErrorStarting = Date.parse(fechafinal) < Date.parse(fechainicial) && this.dailyFrecuency !== 'Once' ? true : false;
  }

  showToast(message: string, type: BzgToastType, duration: number) {
    this._toastService.open(
      message,
      {
        type,
        duration: duration,
        verticalPosition: 'bottom',
        horizontalPosition: 'right'
      });
    }
}
